// extracted by mini-css-extract-plugin
module.exports = {"bg":"TFNOjhIzLo60-FtFaYCw1","preview":"_2Md9tT7PYb-VWOWpkDJxVl"};